import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ISearchTransferResultPayload } from '../../../types';

/**
 * This key is used to track useTransferListQuery
 */
export const TRANSFER_LIST_QUERY_KEY = 'transfer-list-query-key';

/**
 * This hook fetches the transfer list.
 */
export const useTransferListQuery = (payload: ISearchTransferResultPayload) => {
  const { limit, page, inventoryTransferFilterType, filter, search } = payload;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      TRANSFER_LIST_QUERY_KEY,
      page,
      limit,
      filter,
      search,
      inventoryTransferFilterType,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getTransferList({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * (limit || 20);

      return currentCount < lastPage.totalCount ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
